import { useCallback } from 'react';
import { AppDispatch } from 'redux/store';
import { useDispatch } from 'react-redux';
import { RoleModel } from 'types/entity';
import { useAppSelector } from 'hooks';
import { unwrapResult } from '@reduxjs/toolkit';
import { unusedRoleReadQuery } from './unused-role-read.selector';
import { unusedRoleReadActions } from './unused-role-read.slice';

export const useUnusedRoleReadFacade = () => {
  const dispatch: AppDispatch = useDispatch();

  /** 未使用役割一覧 */
  const unusedRoles: RoleModel[] = useAppSelector(unusedRoleReadQuery.getRoles);

  /** 最新の一覧へ置換 */
  const update = useCallback(
    (roles: RoleModel[]) => dispatch(unusedRoleReadActions.replaceAll(roles)),
    [dispatch],
  );

  /** 一覧取得 */
  const loadRoles = useCallback(
    (projectId: string) => dispatch(unusedRoleReadActions.loadUnUsedRoles(projectId)).then(unwrapResult),
    [dispatch],
  );

  return {
    unusedRoles,
    update,
    loadRoles,
  };
};
